import { useState, useCallback } from 'react';
import * as tracking from 'dibs-tracking';

const ITEMS_REFETCH_LIMIT = 4;

type PaginationHooks = {
    onClickArrow: (direction: string) => void;
    onCarouselReset: () => void;
};

export const usePaginationHooks = (
    loadNext: (count: number) => void,
    options?: { itemsRefetchLimit?: number; label?: string }
): PaginationHooks => {
    const { itemsRefetchLimit = ITEMS_REFETCH_LIMIT, label = 'pdp carousel' } = options || {};
    const [hasFetchedAllImages, setHasFetchedAllImages] = useState(false);
    const onClickArrow = useCallback(() => {
        if (!hasFetchedAllImages) {
            setHasFetchedAllImages(true);
            loadNext(itemsRefetchLimit);
        }
        tracking.trackEvent(
            {
                label,
                category: 'product',
                isInteractiveEvent: true,
                action: 'pdp module arrow click',
            },
            null
        );
    }, [hasFetchedAllImages, itemsRefetchLimit, loadNext, label]);

    const onCarouselReset = useCallback(() => {
        setHasFetchedAllImages(false);
    }, []);

    return {
        onClickArrow,
        onCarouselReset,
    };
};
